const initState = {
  educationData: [],
  hasMoreEducation: true,
  lastDocumentOfEducation: null,
};

const adminEducationReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_EDUCATION":
      return {
        ...state,
        educationData: action.payload.data,
        hasMoreEducation: action.payload.hasMoreDocument,
        lastDocumentOfEducation: action.payload.lastDocument,
      };
    case "MORE_GET_EDUCATION":
      return {
        ...state,
        educationData: [...state.educationData, ...action.payload.data],
        hasMoreEducation: action.payload.hasMoreDocument,
        lastDocumentOfEducation: action.payload.lastDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default adminEducationReducer;
